"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ExerciseMatchMediaWrapper = function ExerciseMatchMediaWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "languageId", _descriptor, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "width",
      get: function get() {
        return _state.DeckUI.layout.deckWidth - 20;
      }
    }, {
      key: "height",
      get: function get() {
        return _state.DeckUI.layout.contentHeight - 20;
      }
    }, {
      key: "exercise",
      get: function get() {
        return this.props.exercise || _state.ExerciseUI.exercise;
      }
    }, {
      key: "mediaOptionWidth",
      get: function get() {
        if (this.props.inDeck) {
          if (_state.DeckUI.layout.isNative) {
            var _dimension = Math.min(this.height, this.width);
            return Math.max(80, Math.floor((_dimension - 70) / 2));
          }
          var dimension = Math.min(this.height, this.width);
          return Math.max(80, Math.floor((dimension - 150) / 2));
        } else {
          return '23%';
        }
      }
    }, {
      key: "mediaOptionWidthForExerciseEntry",
      value: function mediaOptionWidthForExerciseEntry(exerciseEntry) {
        if (this.props.inDeck || (0, _utils.isBlank)(exerciseEntry) || (0, _utils.isBlank)(exerciseEntry.mediaOptions) || _state.ExerciseUI.layout.viewportWidth > 1190) {
          return this.mediaOptionWidth;
        }
        if (_state.ExerciseUI.layout.viewportWidth < 700) {
          var _width = Math.floor(100 / (exerciseEntry.mediaOptions.length / 2)) - 2;
          return "".concat(_width.toString(), "%");
        }
        var width = Math.floor(100 / exerciseEntry.mediaOptions.length) - 2;
        return "".concat(width.toString(), "%");
      }
    }, {
      key: "onClick",
      value: function onClick(exerciseEntry, mediaOption) {
        if (!exerciseEntry.revealed && (!this.props.cardState || !this.props.cardState.revealed)) {
          var _exerciseEntry$state$;
          // exerciseEntry.state.set('submittedValue', mediaOption.id);
          if (!((_exerciseEntry$state$ = exerciseEntry.state.submittedValue) !== null && _exerciseEntry$state$ !== void 0 && _exerciseEntry$state$.includes(mediaOption.id))) {
            if ((0, _utils.isPresent)(exerciseEntry.state.submittedValue) && exerciseEntry.numberOfCorrectOptions > 1 && exerciseEntry.selectAllCorrectOptions) {
              exerciseEntry.state.set('submittedValue', [exerciseEntry.state.submittedValue, mediaOption.id].join(','));
            } else {
              exerciseEntry.state.set('submittedValue', mediaOption.id);
            }
          } else if ((0, _utils.isPresent)(exerciseEntry.state.submittedValue) && exerciseEntry.numberOfCorrectOptions > 1 && exerciseEntry.selectAllCorrectOptions) {
            exerciseEntry.state.set('submittedValue', exerciseEntry.state.submittedValue.split(',').filter(function (item) {
              return item !== mediaOption.id;
            }).join(','));
          } else {
            exerciseEntry.state.set('submittedValue', null);
          }
          if (this.props.inDeck && !(exerciseEntry.selectAllCorrectOptions && exerciseEntry.numberOfCorrectOptions > 1)) {
            _state.DeckUI.showExerciseAnswer(this.props.card, this.props.cardState, this.props.userCard);
          }
        }
      }
    }, {
      key: "border",
      value: function border(mediaOption, exerciseEntry) {
        var _exerciseEntry$state$2, _exerciseEntry$state$3;
        if (!exerciseEntry.state.revealed && (_exerciseEntry$state$2 = exerciseEntry.state.submittedValue) !== null && _exerciseEntry$state$2 !== void 0 && _exerciseEntry$state$2.includes(mediaOption.id)) {
          return '10px solid gray';
        }
        if (exerciseEntry.state.revealed && mediaOption.selected) {
          return "10px solid ".concat(_constants.Theme.green);
        }
        if (exerciseEntry.state.revealed && (_exerciseEntry$state$3 = exerciseEntry.state.submittedValue) !== null && _exerciseEntry$state$3 !== void 0 && _exerciseEntry$state$3.includes(mediaOption.id) && !exerciseEntry.state.correct && !exerciseEntry.state.blankValueFilledIn) {
          return "10px solid ".concat(_constants.Theme.red);
        }
        return '10px solid #FFF';
      }
    }, {
      key: "setLanguageId",
      value: function setLanguageId(languageId) {
        this.languageId = languageId;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          exercise: this.exercise,
          languageId: this.languageId,
          width: this.width,
          height: this.height,
          mediaOptionWidth: this.mediaOptionWidth,
          onClick: this.onClick,
          border: this.border,
          setLanguageId: this.setLanguageId,
          mediaOptionWidthForExerciseEntry: this.mediaOptionWidthForExerciseEntry
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.DeckUI.deckStore.showData.languageId || 'DE';
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "width", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "width"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "height", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "height"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "exercise"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mediaOptionWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaOptionWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mediaOptionWidthForExerciseEntry", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaOptionWidthForExerciseEntry"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "border", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "border"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setLanguageId"), _class2.prototype), _class2)) || _class;
};
ExerciseMatchMediaWrapper.displayName = 'ExerciseMatchMediaWrapper';
var _default = exports["default"] = ExerciseMatchMediaWrapper;